import { messagesEN } from './lib/intl/en-US';
import { Options } from '@sheerid/jslib';
import { RecursivePartial } from './lib/types/types';
import { getQueryParamsByName } from './lib/utils/browser';


export const programId = '5fdd3b11a0b34519fe345e40';

export const defaultOptions: RecursivePartial<Options> = {
    restApi: {
        serviceUrl: 'https://services.sheerid.com',
    },
    logLevel: 'error',
    useFingerprinting: true,
    messagesWithLocale: {
        'en-US': messagesEN,
    },
};

export const defaultMetadata = {
    redirect_url: encodeURIComponent(getQueryParamsByName('redirect_url')) || '',
    redirect_url_decoded: getQueryParamsByName('redirect_url') || '',
};
